/** Extracts a human-readable filename from a backend file path like
 *  `uuid/.../uuid_My_File.pdf` → `My File.pdf` */
export function cleanFileName(
  raw: string | undefined | null
): string | undefined {
  if (!raw) return undefined;
  const lastSegment = raw.split('/').pop() ?? raw;
  const withoutUuid = lastSegment.replace(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i,
    ''
  );
  return withoutUuid.replaceAll('_', ' ');
}
